import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateRewardsRequest = { rewards: '_reward' };
var _bulkCreateRewardsResponse = { results: '_bulkRewardResult' };
var _bulkGetRewardsRequest = {};
var _bulkGetRewardsResponse = { rewardsInSite: '_rewardsInSite' };
var _bulkRewardResult = { item: '_reward' };
var _couponReward = {
    minimumSubtotal: 'DOUBLE',
    fixedAmount: '_fixedAmountDiscount',
    percentage: '_percentageDiscount',
};
var _createRewardRequest = { reward: '_reward' };
var _createRewardResponse = { reward: '_reward' };
var _deleteRewardRequest = {};
var _deleteRewardResponse = {};
var _fixedAmountDiscount = { configsByTier: '_fixedAmountDiscountConfig' };
var _fixedAmountDiscountConfig = { amount: 'DOUBLE' };
var _getRewardRequest = {};
var _getRewardResponse = { reward: '_reward' };
var _listRewardsInTierRequest = {};
var _listRewardsInTierResponse = { rewards: '_reward' };
var _listRewardsRequest = {};
var _listRewardsResponse = { rewards: '_reward' };
var _percentageDiscount = { configsByTier: '_percentageDiscountConfig' };
var _percentageDiscountConfig = { percentage: 'DOUBLE' };
var _queryRewardsRequest = {};
var _queryRewardsResponse = { rewards: '_reward' };
var _reward = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    couponReward: '_couponReward',
};
var _rewardsInSite = { rewards: '_reward' };
var _updateRewardRequest = { reward: '_reward' };
var _updateRewardResponse = { reward: '_reward' };
function resolveComWixpressLoyaltyRewardLoyaltyRewardsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/loyalty-rewards',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/loyalty-rewards',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/loyalty-rewards',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/loyalty-rewards',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/loyalty-rewards',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/loyalty-rewards',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/loyalty-rewards',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/loyalty-rewards',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/loyalty-rewards',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/loyalty-rewards',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/loyalty-rewards',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a reward that customers can redeem with loyalty points.
 *
 * When a customer redeems a reward, a loyalty coupon is created
 * based on the specifications detailed in the `discountAmount` or `couponReward` fields. The customer can
 * then use this coupon to receive the discount. Note that while the Rewards API uses coupon scopes and specifications,
 * no coupon is actually created until a customer redeems a reward with points.
 * See the Coupons API for more information about coupons. You can't update the `type` of reward after it's created.
 *
 * A reward's `active` status defaults to `false`. To make the reward available to customers,
 * either set the `active` field to `true` during creation or call Update Reward
 * to change the status.
 *
 * To customize a reward for each loyalty tier, use `configsByTier`.
 * This allows you to specify the amount of the earned discount, the cost in loyalty points
 * to redeem the reward, and the tier to which this configuration applies. Each tier requires its own
 * `configsByTier` configuration. To create a reward that's available to loyalty accounts in the base tier,
 * leave the `tierId` field empty. See the Tiers API for more information on tiers.
 */
export function createReward(payload) {
    var _a = serializer(_createRewardRequest, {
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createRewardResponse, {
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
    }).fromJSON;
    function __createReward(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.reward',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.reward.LoyaltyRewards.CreateReward',
            url: resolveComWixpressLoyaltyRewardLoyaltyRewardsUrl({
                protoPath: '/v1/rewards',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createReward.fromReq = fromReq;
    __createReward.__isAmbassador = true;
    return __createReward;
}
/** Creates multiple rewards. */
export function bulkCreateRewards(payload) {
    var _a = serializer(_bulkCreateRewardsRequest, {
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateRewardsResponse, {
        _bulkRewardResult: _bulkRewardResult,
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
    }).fromJSON;
    function __bulkCreateRewards(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.reward',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.reward.LoyaltyRewards.BulkCreateRewards',
            url: resolveComWixpressLoyaltyRewardLoyaltyRewardsUrl({
                protoPath: '/v1/bulk/rewards/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateRewards.fromReq = fromReq;
    __bulkCreateRewards.__isAmbassador = true;
    return __bulkCreateRewards;
}
/** Retrieves a reward. */
export function getReward(payload) {
    var _a = serializer(_getRewardRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRewardResponse, {
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
    }).fromJSON;
    function __getReward(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.reward',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.reward.LoyaltyRewards.GetReward',
            url: resolveComWixpressLoyaltyRewardLoyaltyRewardsUrl({
                protoPath: '/v1/rewards/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getReward.fromReq = fromReq;
    __getReward.__isAmbassador = true;
    return __getReward;
}
/**
 * Retrieves rewards from all metasites that the caller is a member of.
 *
 * Must be called with user identity.
 */
export function bulkGetRewards(payload) {
    var _a = serializer(_bulkGetRewardsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetRewardsResponse, {
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
        _rewardsInSite: _rewardsInSite,
    }).fromJSON;
    function __bulkGetRewards(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.reward',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.reward.LoyaltyRewards.BulkGetRewards',
            url: resolveComWixpressLoyaltyRewardLoyaltyRewardsUrl({
                protoPath: '/v1/bulk/rewards',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetRewards.fromReq = fromReq;
    __bulkGetRewards.__isAmbassador = true;
    return __bulkGetRewards;
}
/**
 * Retrieves a list of rewards with the specified paging, filtering, and sorting.
 *
 * Query Rewards runs with these defaults, which you can override: `cursorPaging.limit` is `50`.
 *
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language),[Sorting and Paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging),and [Field Projection](https://dev.wix.com/docs/rest/articles/get-started/field-projection).
 */
export function queryRewards(payload) {
    var _a = serializer(_queryRewardsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryRewardsResponse, {
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
    }).fromJSON;
    function __queryRewards(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.reward',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.reward.LoyaltyRewards.QueryRewards',
            url: resolveComWixpressLoyaltyRewardLoyaltyRewardsUrl({
                protoPath: '/v1/rewards/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryRewards.fromReq = fromReq;
    __queryRewards.__isAmbassador = true;
    return __queryRewards;
}
/**
 * Updates a loyalty reward.
 *
 * Call this method to update details of a reward, such as the name, whether a reward is active,
 * or the amount of points it costs to redeem. Also call this method to add new tiers that are eligible to redeem a reward.
 *
 * You may not change the `type` of a reward. That's set upon creation and can't be updated.
 */
export function updateReward(payload) {
    var _a = serializer(_updateRewardRequest, {
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateRewardResponse, {
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
    }).fromJSON;
    function __updateReward(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.reward',
            method: 'PUT',
            methodFqn: 'com.wixpress.loyalty.reward.LoyaltyRewards.UpdateReward',
            url: resolveComWixpressLoyaltyRewardLoyaltyRewardsUrl({
                protoPath: '/v1/rewards/{reward.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateReward.fromReq = fromReq;
    __updateReward.__isAmbassador = true;
    return __updateReward;
}
/** Deletes a reward. */
export function deleteReward(payload) {
    var _a = serializer(_deleteRewardRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteRewardResponse, {}).fromJSON;
    function __deleteReward(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.reward',
            method: 'DELETE',
            methodFqn: 'com.wixpress.loyalty.reward.LoyaltyRewards.DeleteReward',
            url: resolveComWixpressLoyaltyRewardLoyaltyRewardsUrl({
                protoPath: '/v1/rewards/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteReward.fromReq = fromReq;
    __deleteReward.__isAmbassador = true;
    return __deleteReward;
}
/**
 * Retrieves a list of rewards.
 *
 * The list includes rewards that are currently nonredeemable due to insufficient points held by any customers.
 */
export function listRewards(payload) {
    var _a = serializer(_listRewardsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listRewardsResponse, {
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
    }).fromJSON;
    function __listRewards(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.reward',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.reward.LoyaltyRewards.ListRewards',
            url: resolveComWixpressLoyaltyRewardLoyaltyRewardsUrl({
                protoPath: '/v1/rewards',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listRewards.fromReq = fromReq;
    __listRewards.__isAmbassador = true;
    return __listRewards;
}
/**
 * Retrieves a list of rewards in a specified tier.
 *
 * Filters out rewards that don't have configuration in a specified tier.
 */
export function listRewardsInTier(payload) {
    var _a = serializer(_listRewardsInTierRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listRewardsInTierResponse, {
        _couponReward: _couponReward,
        _fixedAmountDiscount: _fixedAmountDiscount,
        _fixedAmountDiscountConfig: _fixedAmountDiscountConfig,
        _percentageDiscount: _percentageDiscount,
        _percentageDiscountConfig: _percentageDiscountConfig,
        _reward: _reward,
    }).fromJSON;
    function __listRewardsInTier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.reward',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.reward.LoyaltyRewards.ListRewardsInTier',
            url: resolveComWixpressLoyaltyRewardLoyaltyRewardsUrl({
                protoPath: '/v1/rewards-in-tier',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listRewardsInTier.fromReq = fromReq;
    __listRewardsInTier.__isAmbassador = true;
    return __listRewardsInTier;
}
//# sourceMappingURL=http.impl.js.map